import Vue from 'vue';
import Vuex from 'vuex';

import appointment from './modules/appointment/index.js';
import automation from './modules/automation/index.js';
import chat from './modules/chat/index.js';
import contact from './modules/contact/index.js';
import campaign from './modules/campaign/index.js';
import payment from './modules/payment/index.js';
import setting from './modules/setting/index.js';

import actions from './actions.js';
import getters from './getters.js';
import mutations from './mutations.js';
import state from './state.js';

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    getters,
    mutations,
    modules: {
        appointment,
        automation,
        chat,
        contact,
        campaign,
        payment,
        setting,
    },
    state: { ...state },
    strict: process.env.NODE_ENV !== 'production',
});
